import { Component, type OnInit } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { environment } from '@tv3/environments/environment'
import { AuthService } from '@tv3/services/auth.service'

@Component({
  selector: 'app-download-app',
  templateUrl: './download-app.html',
  styleUrls: ['./download-app.scss'],
})
export class DownloadApp implements OnInit {
  activeTab: 'ios' | 'android' = 'ios'
  iosUrl = 'https://apps.apple.com/pk/app/advancecm/id6751153263'
  androidUrl = 'https://play.google.com/store/apps/details?id=cm.advance.mapp'

  constructor(private auth: AuthService, public dialogRef: MatDialogRef<DownloadApp>) {}

  close() {
    this.dialogRef.close()
  }
  ngOnInit(): void {}
}
